// Filtre dropdown'larinda gosterilen ulkeler. Su an sadece Turkiye ile calisiyoruz.
// Eski kayitlardaki ulke degerleri (Azerbaycan, Global vb.) veritabaninda duruyor;
// burada listelenmedikleri icin sadece filtreden secilemiyorlar.
export const countryOptions = [
  { value: "Türkiye", label: "Türkiye" },
];
